import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {PUT_UPDATE_ACCESS_ROLE_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
interface UpdateAccessMatrixRequestListItem {
  modules: number[];
  id: number;
}

export interface PutUpdateAccessRoleRequest {
  updatedRoles: UpdateAccessMatrixRequestListItem[];
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePutUpdateAccessRole = ({onSuccess, onError}: Input = {}) => {
  const putUpdateAccessRole = async (reqBody: PutUpdateAccessRoleRequest) => {
    await axiosClient.put<void>(PUT_UPDATE_ACCESS_ROLE_URL, reqBody);
  };

  return useCustomMutation(putUpdateAccessRole, {
    onSuccess,
    onError,
  });
};
